import useBrowserStorage from 'src/internal/browserStorage/useBrowserStorage';
import localStorage from 'src/internal/localStorage/localStorage';
import useDataConfig from 'src/public/useDataConfig';

import type {BrowserStorageHook} from 'src/internal/browserStorage/useBrowserStorage';

type LocalStorageHook = BrowserStorageHook;

/**
 *
 * @see https://sail.stripe.me/data/api/useLocalStorage
 */
export default function useLocalStorage(
  /* Key of the localStorage to interact with */
  key: string,
): LocalStorageHook {
  const dataConfig = useDataConfig();

  return useBrowserStorage(dataConfig.browserStorage, localStorage, key);
}
